module.exports = __webpack_public_path__ + "media/images/green-check-6f320291c7fb56ce0db783de2a10511b.svg";